for (const el of document.querySelectorAll('.vp-block-offers')) {
  const list = el.querySelector('.list')
  const noResults = el.querySelector('.no-results')
  const items = el.querySelectorAll('.list .item')
  const selectRegions = el.querySelector('.filters .regions')
  const selectTypes = el.querySelector('.filters .types select')
  const posts_per_page = parseInt(el.dataset.page, 10)
  const actions = el.querySelector('.actions')
  const moreBtn = el.querySelector('.actions button')
  const delay = 100
  const url = new URL(document.location.href)

  selectRegions.addEventListener('input', () => {
    const value = [...selectRegions.querySelectorAll('input:checked')]
      .map((e) => e.value)
      .join('|')

    if (value === '') {
      url.searchParams.delete('regions')
    } else {
      url.searchParams.set('regions', value)
    }

    history.replaceState(null, '', url.href)
    unfilter()
    filter()
    more()
    scroll()
    selectRegions.blur()
  })

  selectTypes.addEventListener('input', (e) => {
    const target = e.target
    if (target.value === '') {
      url.searchParams.delete('types')
    } else {
      url.searchParams.set('types', target.value)
    }

    history.replaceState(null, '', url.href)
    unfilter()
    filter()
    more()
    scroll()
  })

  // reinit list items
  const unfilter = () => {
    for (const item of items) {
      item.classList.add('hidden')
      item.classList.remove('filtered')
    }
  }

  // set filters
  const filter = () => {
    const regions = url.searchParams
      .get('regions')
      ?.split('|')
      ?.map((v) => parseInt(v, 10))
    const types = url.searchParams
      .get('types')
      ?.split('|')
      ?.map((v) => parseInt(v, 10))

    // update values
    if (regions && regions.length) {
      const labels = []
      for (const value of regions) {
        const label = selectRegions.querySelector(`input[value="${value}"]`)
          ?.parentElement.textContent
        if (label) {
          labels.push(label)
        }
      }
      selectRegions.querySelector('.value').innerHTML = labels.join(', ')
    } else {
      selectRegions.querySelector('.value').innerHTML =
        selectRegions.dataset.placeholder
    }

    selectTypes.value = types?.join() || ''

    // set filters
    let hasNoResults = true
    let regionsExists = []
    let typesExists = []
    for (const item of items) {
      const region = parseInt(item.dataset.region, 10)
      const type = parseInt(item.dataset.type, 10)
      regionsExists.push(region)
      typesExists.push(type)
      let filtered = false
      if (regions && !regions.includes(region)) {
        filtered = true
      }
      if (types && !types.includes(type)) {
        filtered = true
      }
      if (filtered) {
        item.classList.add('filtered')
      } else {
        hasNoResults = false
      }
    }

    // remove unused options
    regionsExists = [...new Set(regionsExists)]
    for (const item of selectRegions.querySelectorAll('input')) {
      const id = parseInt(item.value)
      if (!regionsExists.includes(id)) {
        item.parentElement.remove()
      }
    }
    typesExists = [...new Set(typesExists)]
    for (const item of selectTypes.querySelectorAll('option')) {
      const id = parseInt(item.value)
      if (!isNaN(id) && !typesExists.includes(id)) {
        item.remove()
      }
    }

    // check if results
    if (hasNoResults) {
      list.classList.add('hidden')
      noResults.classList.remove('hidden')
    } else {
      list.classList.remove('hidden')
      noResults.classList.add('hidden')
    }
  }

  // show unfiltered items
  const more = () => {
    const items = el.querySelectorAll('.list .item.hidden:not(.filtered)')
    let hideActions = false
    for (const [i, item] of items.entries()) {
      if (i < posts_per_page) {
        setTimeout(() => {
          item.classList.remove('hidden')
        }, i * delay)
      } else {
        hideActions = true
      }
    }
    actions.style.display = hideActions ? 'inline-flex' : 'none'
  }

  moreBtn.addEventListener('click', more)

  // scroll to list
  const scroll = () => {
    const hasRegions = new URL(document.location).searchParams.has('regions')
    const hasTypes = new URL(document.location).searchParams.has('types')
    if (hasRegions || hasTypes) {
      const adminBar = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--admin-bar'
        ),
        10
      )
      const headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--header-height'
        ),
        10
      )

      window.scrollTo({
        top: el.offsetTop + selectRegions.offsetTop - adminBar - headerHeight,
        left: 0,
        behavior: 'smooth',
      })
    }
  }
  // /scroll to list

  filter()
  more()
  scroll()
}
